import AppBar from "@material-ui/core/AppBar";
import clsx from "clsx";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import ExitToAppRoundedIcon from "@material-ui/icons/ExitToAppRounded";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import NotificationsNoneRoundedIcon from "@material-ui/icons/NotificationsNoneRounded";
import PersonOutlineRoundedIcon from "@material-ui/icons/PersonOutlineRounded";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ConfirmationDialog from "../../../../../utilities/components/ConfirmationDialog/ConfirmationDialog";
import { logoutUser } from "../../../../../utilities/storage";
import { useStyles } from "./styles";

const AppHeader = ({ open, user, selectedDept, updates }) => {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openLogoutConfirmationDialog, setOpenLogoutConfirmationDialog] =
    useState(false);

  const getRoleLabel = () => {
    if (!user) return "";
    const roleName = user.Roles[0].name;
    if (roleName === "Super Admin") return "Eira Super Admin";
    if (roleName === "Org Admin") return "Location Admin";
    return roleName;
  };

  const notificationCount = updates
    ? updates.count
    : selectedDept
    ? selectedDept.notifications
    : 0;

  const getInitials = () => {
    if (!user) return "";
    const first = user.firstName ? user.firstName.charAt(0) : "";
    const last = user.lastName ? user.lastName.charAt(0) : "";
    return `${first}${last}`.toUpperCase();
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = () => {
    history.push("/newUpdates");
  };

  const handleProfileClick = () => {
    handleMenuClose();
    history.push("/profile");
  };

  const onLogout = () => {
    logoutUser();
    history.push("/login");
    window.location.reload();
  };

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, { [classes.appBarShift]: open })}
      elevation={0}
    >
      <Toolbar className={classes.toolbar} disableGutters>
        <Box flexGrow={1} />

        <Box className={classes.rightSection}>
          <Tooltip title="Notifications">
            <IconButton
              className={classes.notificationButton}
              onClick={handleNotificationClick}
              aria-label="notifications"
            >
              <Badge
                badgeContent={notificationCount}
                color="secondary"
                showZero={false}
              >
                <NotificationsNoneRoundedIcon />
              </Badge>
            </IconButton>
          </Tooltip>

          <Box className={classes.divider} />

          <Button
            className={classes.profileButton}
            classes={{ label: classes.profileButtonLabel }}
            onClick={handleMenuOpen}
            aria-haspopup="true"
          >
            <Avatar
              className={classes.avatar}
              src={user && user.imageUrl ? user.imageUrl : undefined}
            >
              {getInitials()}
            </Avatar>
            {user && (
              <Box className={classes.userDetails}>
                <Typography className={classes.name}>
                  {user.firstName} {user.lastName}
                </Typography>
                <Typography className={classes.role}>
                  {getRoleLabel()}
                </Typography>
              </Box>
            )}
            <KeyboardArrowDownRoundedIcon className={classes.caret} />
          </Button>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            classes={{ paper: classes.menuPaper }}
          >
            <MenuItem onClick={handleProfileClick}>
              <ListItemIcon className={classes.menuIcon}>
                <PersonOutlineRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="My Profile" />
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleMenuClose();
                setOpenLogoutConfirmationDialog(true);
              }}
            >
              <ListItemIcon className={classes.menuIcon}>
                <ExitToAppRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>

      <ConfirmationDialog
        title="Logout"
        message="Are you sure you want to logout?"
        open={openLogoutConfirmationDialog}
        setOpen={setOpenLogoutConfirmationDialog}
        onConfirm={onLogout}
      />
    </AppBar>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.loggedInUser,
    selectedDept: state.ayucareUsers.selectedDept,
    updates: state.newUpdates.updates,
  };
};

export default connect(mapStateToProps)(AppHeader);
